<template>
  <va-card class="chart-widget" :title="$t('Instaviral')">
    <div class="flex xs12 md4 tiktok-statistics">
      <va-date-picker
        :label="$t('forms.dateTimePicker.range')"
        :config="{ mode: 'range', dateFormat: 'Y-m-d' }"
        v-model="range"
      />
    </div>
    <va-chart :style="{ height: '500px' }" :data="requestsStatistics" type="line" />
    <div class="flex xs12 md3">
      <va-select
        v-model="limit"
        :label="'Limit'"
        :options="[
          '10',
          '20',
          '40',
          '80',
          '100',
          '200',
          '300',
          '400',
          '500',
          '1000',
        ]"
        noClear
      />
    </div>
    <va-data-table :fields="fields" :data="requests" :per-page="parseInt(limit)">
      <template slot="status" slot-scope="props">
        <span
          :class="{
            success: props.rowData.success,
            error: !props.rowData.success,
          }"
        >
          {{ props.rowData.success ? 'SUCCESS' : 'ERROR' }}
        </span>
      </template>
    </va-data-table>
  </va-card>
</template>

<script>
import axios from 'axios'

const dt = new Date()
export default {
  data () {
    return {
      requests: [],
      requestsStatistics: {},
      limit: '100',
      range: `2021-09-01 to ${dt.getFullYear()}-${(dt.getMonth() + 1 < 10 ? '0' : '') + (dt.getMonth() + 1)}-${(dt.getDate() < 10 ? '0' : '') + dt.getDate()}`,
    }
  },
  methods: {
    getRequests () {
      return axios
        .get(
          `https://api.instaviral.io/api/v1/requests/?limit=${this.limit}`,
          // {auth: {}},
        )
        .then(({ data }) => {
          this.requests = data.results
        })
    },
    getRequestsStatistics () {
      return axios
        .get(
          `https://api.instaviral.io/api/v1/statistics/?start_date=${this.range.replace(
                ' to ',
                '&end_date=',
              )}`,
          // {auth: {}},
        )
        .then(({ data }) => {
          const res = { labels: [] }

          res.datasets = [
            { data: [], label: 'avg_time' },
            { data: [], label: 'failed', backgroundColor: '#ff000085' },
            { data: [], label: 'succeeded', backgroundColor: '#0080007a' },
          ]

          Object.entries(data.statistics_per_day).forEach(([k, v]) => {
            res.datasets[0].data.push(v.avg_time)
            res.datasets[1].data.push(v.failed)
            res.datasets[2].data.push(v.succeeded)
            res.labels.push(k)
          })
          this.requestsStatistics = res
        })
    },
  },
  async beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.getRequests()
      vm.getRequestsStatistics()
    })
  },
  computed: {
    fields () {
      const parseDate = this.parseDate
      return [
        {
          name: 'id',
          title: 'id',
        },
        {
          name: 'spent_time',
          title: 'Spent time',
        },
        {
          name: 'timestamp',
          title: 'date',
          callback (value) {
            return parseDate(value)
          },
        },
        {
          name: '__slot:status',
          title: 'status',
        },
        {
          name: 'is_primary_API',
          title: 'is primary api',
          callback (value) {
            return value !== null ? value : '-'
          },
        },
        {
          name: 'uri',
          title: 'uri',
          callback (value) {
            return value.split('/')[3]
          },
        },
        {
          name: 'argument',
          title: 'argument',
        },
      ]
    },
  },
  watch: {
    range () {
      if (this.range.split(' to ').length === 2) {
        this.getRequestsStatistics()
      }
    },
    limit () {
      this.getRequests()
    },
  },
}
</script>
<style lang="scss">
.success {
  color: green;
}

.error {
  color: red;
}

.usernotfound {
  color: orange;
}

.va-chart {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    height: 100%;
    width: 100%;
  }

  canvas {
    width: 100%;
    height: auto;
  }
}
</style>
